var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 129,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#paper_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 98,
    height: 118,
    rx: 3.063,
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 17.297,
    width: 49.766,
    height: 3.324,
    rx: 1.662,
    fill: "#ADADAD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 71,
    width: 49.766,
    height: 3.324,
    rx: 1.662,
    fill: "#ADADAD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 109,
    width: 49.766,
    height: 3.324,
    rx: 1.662,
    fill: "#ADADAD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 25.621,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 79.324,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 33.945,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 87.648,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 42.27,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 95.973,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 50.594,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.422,
    y: 58.918,
    width: 80.391,
    height: 3.324,
    rx: 1.662,
    fill: "#D5D5D5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "paper_svg__filter0_d",
    x: 0.406,
    y: 0.938,
    width: 107.188,
    height: 127.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.531
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.297
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.917647 0 0 0 0 0.917647 0 0 0 0 0.917647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPaper as ReactComponent };